/**
 * Barrel for generated API. Use: import { api } from '@/api/generated';
 * Types: import type { Sport, Tournament, ... } from '@/api/generated';
 */
export { get4empAppAPI } from './4emp';
export * from './4emp';

import { get4empAppAPI } from './4emp';

/** Singleton API client (uses existing axios with auth interceptors). */
export const api = get4empAppAPI();
